import { http } from '~helpers';

export default () => {
  return {
    getNamespaceSettings: namespaceName => {
      return http(window.fetch, `/api/namespaces/${namespaceName}`);
    },
  };
};



// WEBPACK FOOTER //
// ./client/routes/namespace/namespace-service.js